export function getViewportWidth() {
  return document.documentElement.clientWidth || 0;
}

export function getViewportHeight() {
  return document.documentElement.clientHeight || 0;
}
